// Переклади для системи управління згодою
export const consentTranslations = {
  uk: {
    consent_title: '🍪 Налаштування приватності',
    consent_description:
      'Ми використовуємо файли cookie для покращення вашого досвіду, аналітики та персоналізованої реклами. Оберіть зручні для вас налаштування приватності.',
    consent_accept_all: '✅ Прийняти все',
    consent_necessary_only: '⚙️ Тільки необхідні',
    consent_customize: '🎛️ Налаштувати',
    consent_modal_title: '🔒 Налаштування приватності',
    consent_necessary_title: '📋 Необхідні файли cookie',
    consent_necessary_description:
      'Ці файли cookie необхідні для роботи сайту та не можуть бути відключені.',
    consent_analytics_title: '📊 Аналітичні файли cookie',
    consent_analytics_description:
      'Допомагають зрозуміти, як відвідувачі взаємодіють із сайтом, збираючи та передаючи інформацію анонімно.',
    consent_advertising_title: '🎯 Рекламні файли cookie',
    consent_advertising_description:
      'Використовуються для показу релевантної реклами та вимірювання ефективності рекламних кампаній.',
    consent_always_active: 'Завжди активні',
    consent_save: '✅ Прийняти вибрані',
    consent_close: 'Закрити',
  },
  en: {
    consent_title: '🍪 Privacy Settings',
    consent_description:
      'We use cookies to improve your experience, analytics, and personalized advertising. Choose your preferred privacy settings.',
    consent_accept_all: '✅ Accept All',
    consent_necessary_only: '⚙️ Necessary Only',
    consent_customize: '🎛️ Customize',
    consent_modal_title: '🔒 Privacy Settings',
    consent_necessary_title: '📋 Necessary Cookies',
    consent_necessary_description:
      'These cookies are necessary for the website to function and cannot be disabled.',
    consent_analytics_title: '📊 Analytics Cookies',
    consent_analytics_description:
      'Help us understand how visitors interact with the website by collecting and transmitting information anonymously.',
    consent_advertising_title: '🎯 Advertising Cookies',
    consent_advertising_description:
      'Used to show relevant advertising and measure the effectiveness of advertising campaigns.',
    consent_always_active: 'Always Active',
    consent_save: '✅ Accept Selected',
    consent_close: 'Close',
  },
  cz: {
    consent_title: '🍪 Nastavení soukromí',
    consent_description:
      'Používáme soubory cookie k vylepšení vašeho zážitku, analýz a personalizované reklamy. Vyberte si preferovaná nastavení soukromí.',
    consent_accept_all: '✅ Přijmout vše',
    consent_necessary_only: '⚙️ Pouze nezbytné',
    consent_customize: '🎛️ Přizpůsobit',
    consent_modal_title: '🔒 Nastavení soukromí',
    consent_necessary_title: '📋 Nezbytné soubory cookie',
    consent_necessary_description:
      'Tyto soubory cookie jsou nezbytné pro fungování webu a nelze je zakázat.',
    consent_analytics_title: '📊 Analytické soubory cookie',
    consent_analytics_description:
      'Pomáhají nám pochopit, jak návštěvníci interagují s webem shromažďováním a předáváním informací anonymně.',
    consent_advertising_title: '🎯 Reklamní soubory cookie',
    consent_advertising_description:
      'Používají se k zobrazování relevantní reklamy a měření účinnosti reklamních kampaní.',
    consent_always_active: 'Vždy aktivní',
    consent_save: '✅ Přijmout vybrané',
    consent_close: 'Zavřít',
  },
  de: {
    consent_title: '🍪 Datenschutz-Einstellungen',
    consent_description:
      'Wir verwenden Cookies, um Ihre Erfahrung, Analysen und personalisierte Werbung zu verbessern. Wählen Sie Ihre bevorzugten Datenschutz-Einstellungen.',
    consent_accept_all: '✅ Alle akzeptieren',
    consent_necessary_only: '⚙️ Nur notwendige',
    consent_customize: '🎛️ Anpassen',
    consent_modal_title: '🔒 Datenschutz-Einstellungen',
    consent_necessary_title: '📋 Notwendige Cookies',
    consent_necessary_description:
      'Diese Cookies sind für das Funktionieren der Website erforderlich und können nicht deaktiviert werden.',
    consent_analytics_title: '📊 Analytische Cookies',
    consent_analytics_description:
      'Helfen uns zu verstehen, wie Besucher mit der Website interagieren, indem sie anonym Informationen sammeln und übertragen.',
    consent_advertising_title: '🎯 Werbe-Cookies',
    consent_advertising_description:
      'Werden verwendet, um relevante Werbung anzuzeigen und die Wirksamkeit von Werbekampagnen zu messen.',
    consent_always_active: 'Immer aktiv',
    consent_save: '✅ Ausgewählte akzeptieren',
    consent_close: 'Schließen',
  },
  fr: {
    consent_title: '🍪 Paramètres de confidentialité',
    consent_description:
      'Nous utilisons des cookies pour améliorer votre expérience, les analyses et la publicité personnalisée. Choisissez vos paramètres de confidentialité préférés.',
    consent_accept_all: '✅ Tout accepter',
    consent_necessary_only: '⚙️ Nécessaires seulement',
    consent_customize: '🎛️ Personnaliser',
    consent_modal_title: '🔒 Paramètres de confidentialité',
    consent_necessary_title: '📋 Cookies nécessaires',
    consent_necessary_description:
      'Ces cookies sont nécessaires au fonctionnement du site Web et ne peuvent pas être désactivés.',
    consent_analytics_title: '📊 Cookies analytiques',
    consent_analytics_description:
      'Nous aident à comprendre comment les visiteurs interagissent avec le site Web en collectant et transmettant des informations de manière anonyme.',
    consent_advertising_title: '🎯 Cookies publicitaires',
    consent_advertising_description:
      "Utilisés pour afficher des publicités pertinentes et mesurer l'efficacité des campagnes publicitaires.",
    consent_always_active: 'Toujours actif',
    consent_save: '✅ Accepter les sélectionnés',
    consent_close: 'Fermer',
  },
  es: {
    consent_title: '🍪 Configuración de privacidad',
    consent_description:
      'Utilizamos cookies para mejorar su experiencia, análisis y publicidad personalizada. Elija su configuración de privacidad preferida.',
    consent_accept_all: '✅ Aceptar todo',
    consent_necessary_only: '⚙️ Solo necesarias',
    consent_customize: '🎛️ Personalizar',
    consent_modal_title: '🔒 Configuración de privacidad',
    consent_necessary_title: '📋 Cookies necesarias',
    consent_necessary_description:
      'Estas cookies son necesarias para el funcionamiento del sitio web y no se pueden deshabilitar.',
    consent_analytics_title: '📊 Cookies analíticas',
    consent_analytics_description:
      'Nos ayudan a entender cómo los visitantes interactúan con el sitio web recopilando y transmitiendo información de forma anónima.',
    consent_advertising_title: '🎯 Cookies publicitarias',
    consent_advertising_description:
      'Se utilizan para mostrar publicidad relevante y medir la efectividad de las campañas publicitarias.',
    consent_always_active: 'Siempre activo',
    consent_save: '✅ Aceptar seleccionados',
    consent_close: 'Cerrar',
  },
  zh: {
    consent_title: '🍪 隐私设置',
    consent_description:
      '我们使用Cookie来改善您的体验、分析和个性化广告。请选择您的首选隐私设置。',
    consent_accept_all: '✅ 全部接受',
    consent_necessary_only: '⚙️ 仅必要',
    consent_customize: '🎛️ 自定义',
    consent_modal_title: '🔒 隐私设置',
    consent_necessary_title: '📋 必要Cookie',
    consent_necessary_description:
      '这些Cookie是网站正常运行所必需的，无法禁用。',
    consent_analytics_title: '📊 分析Cookie',
    consent_analytics_description:
      '通过匿名收集和传输信息，帮助我们了解访客如何与网站互动。',
    consent_advertising_title: '🎯 广告Cookie',
    consent_advertising_description: '用于显示相关广告并衡量广告活动的有效性。',
    consent_always_active: '始终启用',
    consent_save: '✅ 接受选中的',
    consent_close: '关闭',
  },
  ru: {
    consent_title: '🍪 Настройки конфиденциальности',
    consent_description:
      'Мы используем файлы cookie для улучшения вашего опыта, аналитики и персонализированной рекламы. Выберите предпочтительные настройки конфиденциальности.',
    consent_accept_all: '✅ Принять все',
    consent_necessary_only: '⚙️ Только необходимые',
    consent_customize: '🎛️ Настроить',
    consent_modal_title: '🔒 Настройки конфиденциальности',
    consent_necessary_title: '📋 Необходимые файлы cookie',
    consent_necessary_description:
      'Эти файлы cookie необходимы для работы сайта и не могут быть отключены.',
    consent_analytics_title: '📊 Аналитические файлы cookie',
    consent_analytics_description:
      'Помогают нам понять, как посетители взаимодействуют с сайтом, собирая и передавая информацию анонимно.',
    consent_advertising_title: '🎯 Рекламные файлы cookie',
    consent_advertising_description:
      'Используются для показа релевантной рекламы и измерения эффективности рекламных кампаний.',
    consent_always_active: 'Всегда активны',
    consent_save: '✅ Принять выбранные',
    consent_close: 'Закрыть',
  },
};
